import React, { useState, useEffect } from 'react'
import { ResumeRepository } from '../../../services/ResumeRepository';
import ResumeEntry, { ResumeEntryObject } from './ResumeEntry'

const SectionResume = () => {
    const resumeRepo = new ResumeRepository();
    const [resumeObjects, setResumeObjects] = useState<ResumeEntryObject[]>(resumeRepo.getAllResumes());

    return (
        <div>
            <h1 className="section-header pb-0">Resume</h1>
            <hr className="w-50 mx-auto" />

            {resumeObjects.map((entry, index) => {
                return <div>

                    <ResumeEntry
                        title={entry.title}
                        subtitle={entry.subtitle}
                        startYear={entry.startYear}
                        endYear={entry.endYear}
                        description={entry.description}>
                    </ResumeEntry>

                    {index < resumeObjects.length - 1 && (
                        <hr />
                    )}

                </div>
            })}

        </div>
    )
}

export default SectionResume
